import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
// Style
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import { graphql, gql, compose } from "react-apollo";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// Component
import Link from "../../Link";

import history from "../../../core/history";
// Locale
import messages from "../../../locale/messages";

import bt from "../../../components/commonStyle.css";
import s from "./SideMenu.css";
class SideMenu extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      ManageListings: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
        })
      ),
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      location: "",
    };
  }

  handleClick() {
    history.push("/become-a-host");
  }
  componentDidMount() {
    // history listener set karna
    this.unlisten = history.listen((location) => {
      this.setState({ location: location.pathname });
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (history.location) {
      this.setState({
        location: history.location.pathname,
      });
    }
  }

  render() {
    const { location } = this.state;
    const {
      data: { ManageListingTransaction },
    } = this.props;
    return (
      <div>
        <ul className={cx("sideMenuBorder", "listLayoutArbic")}>
          <li
            className={cx("sideMenuBorderPadding", {
              ["menuActive"]: location === "/rooms",
            })}
          >
            <Link to={"/rooms"} className={cx("sideNavitem", "sideNav")}>
              <FormattedMessage {...messages.yourListings} />
            </Link>
          </li>
          <li
            className={cx("sideMenuBorderPadding", {
              ["menuActive"]: location === "/reservation/current",
            })}
            onClick={() =>
              this.setState({ location: history.location.pathname })
            }
          >
            <Link
              to={"/reservation/current"}
              className={cx("sideNavitem", "sideNav")}
            >
              <FormattedMessage {...messages.upcomingReservations} />
            </Link>
          </li>
          <li
            className={cx("sideMenuBorderPadding", {
              ["menuActive"]: location === "/reservation/previous",
            })}
            onClick={() =>
              this.setState({ location: history.location.pathname })
            }
          >
            <Link
              to={"/reservation/previous"}
              className={cx("sideNavitem", "sideNav")}
            >
              <FormattedMessage {...messages.previousReservations} />
            </Link>
          </li>
          {ManageListingTransaction && ManageListingTransaction.length > 0 && (
            <li
              className={cx("sideMenuBorderPadding", {
                ["menuActive"]: location === "/users/inbox-message",
              })}
            >
              <Link
                to={"/users/inbox-message"}
                className={cx("sideNavitem", "sideNav")}
              >
                <FormattedMessage
                  {...messages.inboxMessageConfigurationsLabel}
                />
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

// export default injectIntl(withStyles(s, bt)(SideMenu));

const mapState = (state) => ({});

const mapDispatch = {};

export default compose(
  connect(mapState, mapDispatch),
  injectIntl,
  withStyles(s, bt),
  graphql(
    gql`
      {
        ManageListingTransaction {
          id
          title
          isReady
        }
      }
    `,
    {
      options: {
        ssr: false,
      },
    }
  )
)(SideMenu);
